<div role="note" [class]="cardClasses" [style]="cardStyle">
  <span class="flex-item">
    <mat-icon style="color: inherit">{{ iconName }}</mat-icon>
  </span>
  <span class="flex-item">
    <ng-content />
  </span>
</div>
